import React, { FC } from 'react';
import { Slide, useScrollTrigger } from '@mui/material';
import { Props } from './types';

const HideOnScroll: FC<Props> = ({ hide = true, children }) => {
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!hide || !trigger}>
      {children}
    </Slide>
  );
};

export default HideOnScroll;
